import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { css } from '@emotion/css';
import { tabularNums } from '@medcom/shared-ui/styles/globalCss.ts';
import { Button, Flex, Select, theme } from 'antd';
import type React from 'react';

const PAGE_SIZES = [10, 20, 50, 100];

interface PrevNextPagerProps {
  offset: number;
  pageSize: number;
  shown: number;
  hasMore: boolean;
  loading: boolean;
  /** Names what is paged, e.g. "gesendete Anforderungen". */
  label: string;
  onChange: (offset: number, pageSize: number) => void;
}

/** Paging without a total count: back, forward and the page size. */
export const PrevNextPager: React.FC<PrevNextPagerProps> = ({ offset, pageSize, shown, hasMore, loading, label, onChange }) => {
  const { token } = theme.useToken();

  const pagerStyle = css`
    margin-top: ${token.margin}px;
  `;

  return (
    <Flex justify="flex-end" align="center" gap="small" className={pagerStyle}>
      {shown > 0 && <span className={tabularNums}>{`${label} ${offset + 1} bis ${offset + shown}`}</span>}
      <Button
        icon={<LeftOutlined />}
        title="Vorherige Seite"
        disabled={loading || offset === 0}
        onClick={() => onChange(Math.max(0, offset - pageSize), pageSize)}
      />
      <Button
        icon={<RightOutlined />}
        title="Nächste Seite"
        disabled={loading || !hasMore}
        onClick={() => onChange(offset + pageSize, pageSize)}
      />
      <Select
        value={pageSize}
        options={PAGE_SIZES.map(size => ({ value: size, label: `${size} / Seite` }))}
        onChange={size => onChange(Math.floor(offset / size) * size, size)}
      />
    </Flex>
  );
};
